const timelineData = [
    {
        date: '28 April',
        title: 'Timeline event One',
        text: 'It will be as simple as occidental in fact. To an english person, it will seem like simplified English, as a skeptical friend'
    },
    {
        align: 'left',
        date: '21 April',
        title: 'Timeline event Two',
        text: 'To achieve this, it would be necessary to have more common words.'
    },
    {
        date: '15 April',
        title: 'Timeline event Three',
        text: 'The new common language will be more simple and regular than the existing European languages be as simple as occidental',
        images: [require('@/assets/images/small/img-2.jpg'), require('@/assets/images/small/img-3.jpg'), require('@/assets/images/small/img-4.jpg')]
    },
    {
        align: 'left',
        date: '09 April',
        title: 'Timeline event Four',
        text: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, ab illo inventore veritatis et'
    },
    {
        date: '02 April',
        title: 'Timeline event Five',
        text: 'Itaque earum rerum hic tenetur a sapiente delectus, ut aut doloribus asperiores.'
    },
];

export { timelineData };
